import {
  GET_CONSTANTS,
  GET_CONSTANTS_SUCCESS
} from "../constants/serverConstants";

export const getConstants = () => ({
  type: GET_CONSTANTS
});

export const getConstantsSuccess = data => ({
  type: GET_CONSTANTS_SUCCESS,
  payload: data
});
